const HandleCurrentPath = ({staticPath, currentPath})=>{
    const content ="";
    if(staticPath === currentPath){
        return <span className="absolute inset-y-0 left-0 w-1 bg-blue-600 rounded-tr-lg rounded-br-lg" ></span>
    }
    
    //console.log(currentPath + "Static Path: " + staticPath);
    return (
        <>
        {content}
        </>
    );
};

export default HandleCurrentPath;